import { cn } from '@/lib/utils';
import type { Task } from '../types/home-tasks.types';
import { URGENCY_COLORS } from '../types/home-tasks.types';

interface TaskItemProps {
  task: Task;
  onClick: () => void;
}

/**
 * Individual task row component
 * Displays task title with urgency indicator and handles click navigation
 */
export function TaskItem({ task, onClick }: TaskItemProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      className="flex items-center gap-2 py-1.5 px-2 rounded hover:bg-stone-100 cursor-pointer transition-colors"
    >
      <span
        className={cn(
          'w-2 h-2 rounded-full shrink-0',
          URGENCY_COLORS[task.urgency],
        )}
      />
      <span className="text-sm truncate">{task.title}</span>
    </div>
  );
}
